/**
 * CTA público de la web (nav + landing + páginas que traen gente de Google).
 *
 * KAN-289: un usuario con cuenta que cerró sesión seguía viendo "Creá tu
 * cuenta" como botón principal — y ese link abría el formulario de Ingresar.
 * El flag local `mcd:ha-ingresado` marca que ESTE dispositivo ya inició
 * sesión alguna vez (se escribe en signIn/signOut exitosos) y con él el CTA
 * principal pasa a ser "Ingresar". Es por dispositivo, no por persona: en un
 * navegador nuevo el usuario con cuenta vuelve a ver el CTA de registro (el
 * login queda a un link de distancia y /login siempre abre en modo ingreso).
 */
const FLAG_KEY = 'mcd:ha-ingresado';

export function marcarHaIngresado(): void {
  try {
    localStorage.setItem(FLAG_KEY, '1');
  } catch {
    // storage bloqueado/lleno: sólo se pierde el CTA inteligente
  }
}

export function yaIngresoEnEsteDispositivo(): boolean {
  try {
    return localStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
}

export interface CtaPublico {
  label: string;
  to: string;
}

/**
 * CTA principal: logueado → su panel; dispositivo que ya ingresó → Ingresar;
 * visitante nuevo → registro (con ?mode=signup para abrir el form correcto).
 */
export function ctaPublico(user: unknown, labelRegistro = 'Creá tu cuenta gratis'): CtaPublico {
  if (user) return { label: 'Ir a mi panel', to: '/dashboard' };
  if (yaIngresoEnEsteDispositivo()) return { label: 'Ingresar', to: '/login' };
  return { label: labelRegistro, to: '/login?mode=signup' };
}
